import {createEnv} from '@t3-oss/env-core'
import {z} from 'zod'

export const serverEnvSchema = z.object({
  SENTRY_ORG: z.string().min(1),
  SENTRY_PROJECT: z.string().min(1),
  SENTRY_AUTH_TOKEN: z.string().min(1),
})

export const clientEnvSchema = z.object({
  VITE_SENTRY_DNS_URL: z.string().min(1),
})

export const envSchema = serverEnvSchema.merge(clientEnvSchema)

export const getServerEnv = (runtimeEnv: Record<string, string>) => {
  return createEnv({
    clientPrefix: 'VITE_',
    client: clientEnvSchema.shape,
    server: serverEnvSchema.shape,
    runtimeEnv,
    emptyStringAsUndefined: true,
    skipValidation: runtimeEnv.SKIP_ENV_VALIDATION === 'true',
  })
}

export const env = () => {
  const skipValidation =
    typeof process !== 'undefined' ?
      !!process.env.SKIP_ENV_VALIDATION
    : !!import.meta.env.VITE_SKIP_ENV_VALIDATION

  return createEnv({
    clientPrefix: 'VITE_',
    client: clientEnvSchema.shape,
    runtimeEnv: import.meta.env,
    emptyStringAsUndefined: true,
    skipValidation,
  })
}
